import crypto from 'crypto-browserify';
import { selectUser } from '../../state/user/userSlice';
import store from '../../state/store';

// for now this is only for chat
// will only take in list of contacts and take the uids and create the has
const generateChatSessionId = (contactArr) => {
  const user = selectUser(store.getState());

  const destinationArr = [];
  contactArr.forEach((contact) => {
    destinationArr.push(contact.uid);
  });

  destinationArr.push(user.uid);
  destinationArr.push(user.domain);

  destinationArr.sort();

  // add random number only for group chats
  if (contactArr.length > 1) {
    destinationArr.push(Math.random());
  }

  const merged = destinationArr.join('');

  return crypto.createHash('md5').update(merged).digest('hex');
};

export default generateChatSessionId;
